export default function CategoryDirective() {
  return {
    template: require('./category.html'),
    scope: {
      category: '=',
    },
    controller: 'ECATCategoryController',
    controllerAs: 'categoryVM',
    bindToController: true,
    replace: true,
  };
}
